import { slick } from "@accessible360/accessible-slick";

class Media {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.init();
    }

    init() {
        this.createCarousel();
    }

    createCarousel() {
        let nav_id, nav_for;

        nav_id = this.el.dataset.mainCarousel
            ? this.el.dataset.mainCarousel
            : this.el.dataset.navCarousel;
        nav_for = this.el.dataset.mainCarousel
            ? '[data-nav-carousel="' + nav_id + '"]'
            : '[data-main-carousel="' + nav_id + '"]';

        const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 32"><path d="M.9 31A3 3 0 0 0 5 31l12.7-12.7a3 3 0 1 0-4.2-4.3L1 26.7a3 3 0 0 0 0 4.3Z"/><path d="M.9 1a3 3 0 0 0 0 4.3L13.6 18a3 3 0 1 0 4.2-4.3L5.1 1A3 3 0 0 0 1 1Z"/></svg>`;
        const props = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            asNavFor: nav_for ?? null,
            arrowsPlacement: "afterSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                arrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                arrow +
                "</button>",
        };

        if (this.el.dataset.navCarousel) {
            props["arrows"] = false;
            props["slidesToShow"] = 7;
            props["instructionsText"] =
                `Changing the current slide of this carousel will change 
                the current slide of the preceding main image carousel.`;
            props["regionLabel"] = "thumbnail carousel";
            props["responsive"] = [
                { breakpoint: 768, settings: { slidesToShow: 3 } },
            ];
        }

        let carousel = $(this.el).slick(props);
        this.el.carousel = carousel;

        // Then do events,
        const active_class = "media-item-active";
        if (this.el.dataset.navCarousel) {
            this.el.querySelector(".slick-active").classList.add(active_class);
            const buttons = this.el.querySelectorAll("[data-go-to]");

            buttons.forEach((button) => {
                button.addEventListener("click", () => {
                    const carousel_index = button.dataset.carouselIndex;
                    const slide_index = button.dataset.goTo - 1;

                    $('[data-nav-carousel="' + carousel_index + '"]').slick(
                        "slickGoTo",
                        slide_index,
                    );
                });
            });
        }

        if (this.el.dataset.mainCarousel) {
            carousel.on("afterChange", function (e, index) {
                let carousel_index = carousel.data("main-carousel"),
                    slide_index = carousel.slick("slickCurrentSlide");

                let active = document.querySelector("." + active_class);
                if (active) active.classList.remove(active_class);

                document
                    .querySelector(
                        '[data-nav-carousel="' +
                            carousel_index +
                            '"] [data-slick-index="' +
                            slide_index +
                            '"]',
                    )
                    .classList.add(active_class);
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const mediaCarousels = document.querySelectorAll(
        "[data-carousel='media'], [data-carousel='media-nav']",
    );

    mediaCarousels.forEach((element) => {
        new Media(element);
    });
});

export default Media;
